module.exports = __webpack_public_path__ + "static/projekt_indywidualny_a08-b6061fba71ae4ce5edc6e8489d8a8460.jpg";